var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-medal-card",
      class: { "lpu-medal-card--hover": _vm.useHover },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "lpu-medal-card__surface d-flex flex-column align-center rounded-30 border-sm",
          attrs: {
            role: "button",
            tabindex: "0",
            "data-qa": "lpu_medals_card",
          },
          on: {
            click: function ($event) {
              return _setup.emit("open")
            },
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                return _setup.emit("open")
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                )
                  return null
                $event.preventDefault()
                return _setup.emit("open")
              },
            ],
          },
        },
        [
          _c(
            "span",
            {
              staticClass:
                "lpu-medal-card__image-wrap d-flex align-center justify-center",
            },
            [
              _c("img", {
                staticClass: "lpu-medal-card__image",
                attrs: { src: _vm.src, alt: _vm.alt, loading: "lazy" },
              }),
              _vm._v(" "),
              _vm.count > 1
                ? _c(
                    "span",
                    {
                      staticClass:
                        "lpu-medal-card__count text-subtitle-2 text-info--text",
                      attrs: { "data-qa": "lpu_medals_count" },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.count) + "\n      ")]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "lpu-medal-card__details" }, [
            _c(
              "span",
              {
                staticClass:
                  "lpu-medal-card__description text-body-2 text--text text-center",
              },
              [_vm._v("\n        " + _vm._s(_vm.alt) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "lpu-medal-card__more text-body-2 primary--text text-decoration-underline text-center",
                attrs: { href: _vm.href, "data-qa": "lpu_medals_card_more" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_setup.tStatic("Подробнее")) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }